(() => {
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const price = form.querySelector('[data-product-price]');
    const button = form.querySelector('[data-add-button]');
    if (!select) return;

    const updateVariant = () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.querySelector('span').textContent = available ? 'Add to cart' : 'Unavailable';
      }
    };

    select.addEventListener('change', updateVariant);
    updateVariant();
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });
})();
